import React from 'react';
import type { LeadStatusType } from '@api/emailApi';

import { Badge } from '@components/theme-v2/components/Badge';

const statusConfig: Record<
  LeadStatusType,
  { variant: 'default' | 'cyan' | 'green' | 'amber' | 'red' | 'purple'; label: string }
> = {
  NEW: { variant: 'default', label: 'New' },
  CONTACTED: { variant: 'cyan', label: 'Contacted' },
  REPLIED: { variant: 'green', label: 'Replied' },
  INTERESTED: { variant: 'amber', label: 'Interested' },
  MEETING: { variant: 'purple', label: 'Meeting' },
  WON: { variant: 'green', label: 'Won' },
  LOST: { variant: 'red', label: 'Lost' },
};

interface LeadStatusBadgeProps {
  status: LeadStatusType;
  size?: 'sm' | 'md' | 'lg';
}

export const LeadStatusBadge: React.FC<LeadStatusBadgeProps> = ({ status, size = 'sm' }) => {
  const config = statusConfig[status] || statusConfig.NEW;
  return (
    <Badge variant={config.variant} size={size} showDot>
      {config.label}
    </Badge>
  );
};

export default LeadStatusBadge;
